// src/components/AboutUsBanner.js
import React from 'react';
import './DetailsBanner.css'; // We’ll define styles separately

const DetailsBanner = () => {
  return (
    <div className="service-banner text-white d-flex align-items-center">
      <div className="container text-center">
        <h2 className="display-4 fw-bold mt-5">Corporate Parties</h2>
       
      </div>
    </div>
  );
};

export default DetailsBanner;
